import { ref } from "vue";
import Global from "../Global";
import Tools from "../Tools";
import HttpResponse from "../vo/HttpResponse";

export type InputLogin = {
    account: string;
    password: string;
};

export type InputRefreshToken = {
    RefreshToken: string
};

export type LoginTokenType = {
    accessToken: string,
    refreshToken: string,
    invalid?: boolean
}

/**
 * 二维码模式
 */
export enum QRCodeModelEnum {
    /**
     * 返回图片地址的URL
     */
    ImageURL = 0,
    /**
     * 返回Base64字符串
     */
    Base64 = 1
}

/**
 * 全局API
 */
export default class GlobalApi {
    /**
     * 登录
     * @param input 
     * @returns 
     */
    public LoginAsync(input: InputLogin) {
        return Tools.FetchAsync<LoginTokenType>("Global/Login", input, "POST", "application/json", true);
    }

    /**
     * 退出登录
     */
    public LogOutAsync() {
        return Tools.FetchAsync("Global/LogOut", {}, "GET");
    }

    /**
     * 刷新登录Token
     */
    public RefreshTokenAsync(input: InputRefreshToken) {
        return Tools.FetchAsync<LoginTokenType>("Global/RefreshToken", input, "POST", "application/json", true);
    }

    /**
     * 设备登录
     * @param deviceNumber 设备号
     */
    public async DeviceLoginAsync(DeviceNumber: string) {
        let resp = await Tools.FetchAsync<{
            accessToken: string,
            refreshToken: string
        }>("Global/DeviceLogin", {
            DeviceNumber
        }, "POST", "application/json", true);
        if (resp.CheckIsOk()) {
            Global.JwtToken = ref(resp.Data!.accessToken);
            Global.RefreshToken = ref(resp.Data!.refreshToken);
            return true;
        }
        return false;
    }

    /**
     * 上传文件 
     * @param file 要上传的文件
     * @returns 
     */
    public UploadFileAsync(file: File) {
        return Tools.FetchAsync<{
            Etag: string,
            ObjectName: string,
            Size: number
        }>("Global/UploadFile", {
            file
        }, "POST", "multipart/form-data");
    }

    /**
     * 获取系统配置
     */
    public GetSystemConfigAsync() {
        return Tools.FetchAsync<{
            SystemUid: string,
            ResourceFileHost: string,
            UploadFileMaxSize: number,
            MinioResourceURL: string,
            /**
             * 使用的存储桶名称
             */
            MinioUseBucketName: string
        }>("Global/GetSystemConfig", {

        }, "GET", "text/plain", true);
    }

    /**
     * 获取二维码
     * @param text 
     * @param qtCodeModel 获取模式 可以是图片，或者是Base64图 
     * @returns 
     */
    public async GetQRCodeAsync(text: string, qtCodeModel: QRCodeModelEnum): Promise<string | HttpResponse<{ Base64Image: string }>> {
        switch (qtCodeModel) {
            case QRCodeModelEnum.ImageURL:
                let qrUrl = Global.GetAPIUrl("Global/GetQRCode");
                let linkUrl: string = "";

                let blob = await Tools.FetchGetFileAsync(qrUrl, {
                    text: text,
                    qrModel: qtCodeModel
                }, "GET", "text/plain", {});
                linkUrl = URL.createObjectURL(blob);
                return linkUrl;
            case QRCodeModelEnum.Base64:
                return await Tools.FetchAsync<{
                    Base64Image: string
                }>("Global/GetQRCode", {
                    text: text,
                    qrModel: qtCodeModel
                }, "GET","application/json",true);
            default:
                throw new Error("二维码类型异常!");
        }
    }
}